// extracted by mini-css-extract-plugin
module.exports = {"grat-price":"_2ApPmP-MGJBPn9XA4VtQbc","gratuity":"_3Hk8V53KrkjqfC8tOcQARL","list-gratuity":"_2NQq7HpiOJjYP2fcCdEIjv"};